const _ = require('underscore');
const Backbone = require('backbone');
const VirtualCollection = require('backbone-virtual-collection');

const GroupedCollection = (Backbone.GroupedCollection = function(parent, options) {
  if (options.groupBy === undefined) {
    throw new Error('groupBy option must be defined');
  }

  // convert string group criteria to functions
  const getGroupValue = _.isFunction(options.groupBy)
    ? options.groupBy
    : function(model) {
        return model.get(options.groupBy);
      };

  // grouping function
  const createGroup = function(models, groupId) {
    const modelComparator = models[0].collection ? models[0].collection.comparator : null;

    const group = new Backbone.Model({
      id: groupId,
      collection: new VirtualCollection(parent, {
        filter(model) {
          return getGroupValue(model).toString() === groupId.toString();
        },
        comparator: modelComparator
      })
    });

    group.on('remove', () => {
      group.get('collection').stopListening();
    });

    return group;
  };

  // comparator function
  const groupComparator = function(groupA, groupB) {
    if (groupA.id < groupB.id) {
      return -1;
    } else if (groupA.id > groupB.id) {
      return 1;
    }
    return 0;
  };

  // initialize collection
  const groups = _.map(parent.groupBy(getGroupValue), createGroup);
  const collection = new Backbone.Collection(groups, {
    comparator(a, b) {
      const sortOrder = `${options.sortOrder}`.toUpperCase();

      if (sortOrder === 'ASC') {
        return groupComparator(a, b);
      } else if (sortOrder === 'DESC') {
        return -1 * groupComparator(a, b);
      }
      return 0;
    }
  });

  // propage update events
  parent.on('filter update', () => {
    const filteredGroups = _.map(parent.groupBy(getGroupValue), createGroup);

    collection.set(filteredGroups, { add: true, remove: true, merge: false });
  });

  return collection;
});

module.exports = GroupedCollection;



// WEBPACK FOOTER //
// ./src/extensions/grouped-collection.js